import {
    HTML5ImplicitRoles,
    OptionalLabelRoles,
    RequiredLabelRoles,
    PageWidthRoles,
} from './selectors';
import isElementPageScoped from './isElementPageScoped';

// Return the explicitly-defined role, if available; otherwise, try to return
// an implicit role.
export default function getRole(element: Element) {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (15,48): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ ASIDE: string; FOOTER: string; FORM: string; HEADER: string; MAIN: string; NAV: string; SECTION: string; }'.
    // @ts-expect-error
    let role = element.getAttribute('role') || HTML5ImplicitRoles[element.tagName] || null;
    if (
        OptionalLabelRoles.includes(role) ||
        RequiredLabelRoles.includes(role) ||
        (PageWidthRoles.includes(role) && isElementPageScoped(element))
    ) {
        return role;
    }

    return null;
}
